import { Card, CardBody, Col } from 'reactstrap'
import { BasicTimelines } from '../../../../utils/Constant'
import { basicTimeLineData } from '../../../../Data/BonusUi/Timeline/Timeline'
import StaticBasicTimeline from './StaticBasicTimeline'
import DynamicBasicTimeline from './DynamicBasicTimeline'
import { UL } from '../../../../AbstractElements'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const BasicTimeline = () => {
  return (
    <Col xl="6" className="notification main-timeline bol-col-6">
      <Card>
        <CommonCardHeader title={BasicTimelines} span={basicTimeLineData} />
        <CardBody className="dark-timeline">
          <UL className='simple-list'>
            <StaticBasicTimeline />
            <DynamicBasicTimeline />
          </UL>
        </CardBody>
      </Card>
    </Col>
  )
}

export default BasicTimeline
